
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
@Component({
  filters: {
    comment: (value: any) => {
      if (value) {
        return value.substring(0, 10);
      }
    },
  },
})
export default class Detail extends Vue {
  obj: any = {};
  async mounted() {
    const res: any = await getDetail(this.$route.query.id);
    this.obj = res.data;
  }
}
